import { formattingLocales } from './formattingLocale';

/**
 * Locale-aware label helpers for the activity-stats surfaces (pet profile,
 * household stats, device stats). Day/month values are 'YYYY-MM-DD' /
 * 'YYYY-MM' device-local strings from getActivityStats; they are formatted
 * in UTC so the label matches the device-local bucket, not the viewer's zone.
 */

export const userLocale = () => formattingLocales();

export function formatDay(day: string, options: Intl.DateTimeFormatOptions): string {
    return new Intl.DateTimeFormat(userLocale(), { ...options, timeZone: 'UTC' }).format(new Date(`${day}T00:00:00Z`));
}

export function formatMonth(month: string, options: Intl.DateTimeFormatOptions): string {
    return formatDay(`${month}-01`, options);
}

export const formatHour = (hour: number) => `${String(hour % 24).padStart(2, '0')}:00`;

/** Weekday names Monday-first; 2024-01-01 is a Monday. */
export function weekdayNames(style: 'narrow' | 'long'): string[] {
    const formatter = new Intl.DateTimeFormat(userLocale(), { weekday: style, timeZone: 'UTC' });
    return Array.from({ length: 7 }, (_, index) => formatter.format(new Date(Date.UTC(2024, 0, 1 + index))));
}
